import React from "react";

import SecondHandIcon from "components/atoms/SecondHandIcon";

export default ({ record }) => record && record.is_second_hand && <SecondHandIcon />;
